import { PurchaseType } from 'core/logic/purchase/purchase.types'
import PixView from './Pix.view'
import { useMemo } from 'react'
import { toDataURL } from 'qrcode'
import useAsyncMemo from '@onepercentio/one-ui/hooks/utility/useAsyncMemo'

export default function PixLogic({ purchase }: { purchase: PurchaseType }) {
  const [qrcode] = useAsyncMemo(async () => {
    if (purchase.charge.pix.brCode)
      return (await toDataURL(purchase.charge.pix.brCode)).split(',')[1]
    if (purchase.charge.paymentType === 'PIX')
      return purchase.charge.pix.qrcodeBase64
    if (purchase.charge.paymentType === 'PIX_BRLA')
      return (await toDataURL(purchase.charge.pix.brCode)).split(',')[1]
    else return purchase.charge.pix.payloadInBase64
  }, [purchase])

  const pixCopyPaste = useMemo(() => {
    switch (purchase.charge.paymentType) {
      case 'PIX':
      case 'BOLETO_PIX':
        return purchase.charge.pix.qrcode ?? purchase.charge.pix.brCode
      case 'PIX_BRLA':
        return purchase.charge.pix.brCode
      default:
        const buf = Buffer.from(qrcode!, 'base64')
        return buf.toString()
    }
  }, [qrcode, purchase.charge.paymentType, purchase.charge.pix.qrcode])
  if (!qrcode) return null
  return <PixView pixCopyPaste={pixCopyPaste} qrcode={qrcode} />
}
